<template>
    <div id="fastWizardV2">
        <div class="Header">
            <Stepper :go-next-page="activeIndex" @changeStep="stepOnChangeHandler" :steps="steps" />
        </div>
        <div class="wizard-container">
            <FormStep @nextStep="activeIndex = activeIndex + 1" v-if="activeIndex === 0" />
            <ThemeStep v-if="activeIndex === 1" />
            <WorkingHours v-if="activeIndex === 2" />
            <Preview v-if="activeIndex === 3" />
            <SetupPage v-if="activeIndex === 4" />
        </div>
        <div class="footer">
            <div class="footer-button-left">
                <a-button
                    class="next-button"
                    type="primary"
                    ghost
                    size="large"
                    @click="activeIndex = activeIndex - 1"
                    v-if="activeIndex !== 0"
                >
                    <a-icon type="left" />
                    {{ $t("fastWizard.previous") }}
                </a-button>
            </div>
            <div class="footer-text">
                <SupsisIcon style="width: 50px; height: 50px" />
                <h4>{{ $t("fastWizard.setupSupsisLiveChat") }}</h4>
            </div>
            <div class="footer-button-right">
                <a-button
                    type="primary"
                    ghost
                    size="large"
                    @click="activeIndex = activeIndex + 1"
                    v-if="activeIndex !== 4 && activeIndex !== 0"
                >
                    {{ $t("fastWizard.continue") }}
                    <a-icon type="right" />
                </a-button>
                <a-button type="primary" size="large" @click="complete" :disabled="waiting" v-if="activeIndex === 4">
                    {{ $t("fastWizard.completeInitialize") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from "../../components/fastWizardV2/Stepper.vue";
import FormStep from "../../components/fastWizardV2/FormStep.vue";
import ThemeStep from "../../components/fastWizardV2/ThemeStep.vue";
import WorkingHours from "../../components/fastWizardV2/WorkingHours.vue";
import Preview from "../../components/fastWizardV2/Preview.vue";
import SetupPage from "../../components/fastWizardV2/SetupPage.vue";
import SupsisIcon from "./Chatbot/pages/integrations/svg/SupsisIcon.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";

export default {
    name: "FastWizardV2",
    components: { SetupPage, Preview, ThemeStep, FormStep, Stepper, WorkingHours, SupsisIcon },
    data() {
        return {
            steps: [
                { title: this.$t("newWizartV2.generalSettings"), iconName: "Whells" },
                { title: this.$t("newWizartV2.themeSettings"), iconName: "Light" },
                { title: this.$t("newWizartV2.representativeWorkingHours"), iconName: "Back" },
                { title: this.$t("newWizartV2.preview"), iconName: "Dart" },
                { title: this.$t("newWizartV2.setup"), iconName: "Wifi" },
            ],
            activeIndex: 0,
            waiting: false,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        stepOnChangeHandler(activeIndex) {
            this.activeIndex = activeIndex;
        },
        async complete() {
            this.waiting = true;
            const newSettings = await this.setSettingValue({
                setting: "initialized",
                value: true,
            });

            this.$nextTick(() => {
                this.applySettings(newSettings);
                this.waiting = false;
                this.$message.success(this.$t("fastWizard.completedMessage"));
                //window.location.reload();
            });
        },
        applySettings(newSettings) {
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        bubbleIcon() {
            let { customIcon } = this.settings.bubble;
            if (this.newIcon || customIcon) {
                let { path, _id, ext } = this.newIcon || customIcon;
                return `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
            }
            return undefined;
        },
        getStatus(order) {
            if (order < this.current) return "finish";
            if (order === this.current) return "process";
            return "wait";
        },
    },
    watch: {
        current(val) {
            console.log("current changed", val);
        },
    },
};
</script>

<style scoped lang="scss">
#fastWizardV2 {
    width: 100%;
    min-height: 92vh;
    background-color: white;
    z-index: 999999999999999;

    .wizard-container {
        margin-top: 50px;
        margin-bottom: 0px;
    }

    .footer {
        position: fixed;
        z-index: 999999999999999;
        background: #e8e8e8;
        bottom: 0;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .footer-button-left {
        flex: 1;
        display: flex;
        justify-content: flex-start !important;
        margin-left: 10px;
    }

    .footer-button-right {
        flex: 1;
        display: flex;
        justify-content: flex-end !important;
        margin-right: 10px;
    }

    .footer-text {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: end;
        gap: 10px;

        h4 {
            color: #e58741;
            font-family: Verdana;
        }
    }

    .ant-btn-background-ghost.ant-btn-primary {
        color: #ffff;
        background: #ec4b1d !important;
        border-color: #ec4b1d;
        text-shadow: none;
    }

    .ant-btn-primary {
        color: #fff;
        background-color: #ec4b1d;
        border-color: #ec4b1d;
    }
}

@media (max-width: 600px) {
    #fastWizardV2 {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 999999999999999;
    }
    .wizard-container {
        height: calc(100% - 50px);
        overflow-y: auto;
    }

    .footer-text {
        h4 {
            display: none;
            visibility: hidden;
        }
    }
    #fastWizardV2 .ant-btn-background-ghost.ant-btn-primary {
        font-size: 10px !important;
    }
    #fastWizardV2 .ant-btn-primary {
        font-size: 10px !important;
    }
}
</style>
